import Immutable from "immutable";

const LOAD_OPEN_ISSUES_SUCCESS = 'downtimeTracker/LOAD_OPEN_ISSUES_SUCCESS'
const LOAD_OPEN_ISSUES_FAIL = 'downtimeTracker/LOAD_OPEN_ISSUES_FAIL'
const SAVE_NOTES_SUCCESS = 'downtimeTracker/SAVE_NOTES_SUCCESS'
const SAVE_NOTES_FAIL = 'downtimeTracker/SAVE_NOTES_FAIL'
const LOAD_NOTES_SUCCESS = 'downtimeTracker/LOAD_NOTES_SUCCESS'
const LOAD_NOTES_FAIL = 'downtimeTracker/LOAD_NOTES_FAIL'

const CHECK_ISSUES_SUCCESS = 'downtimeTracker/CHECK_ISSUES_SUCCESS'
const CHECK_ISSUES_FAIL = 'downtimeTracker/CHECK_ISSUES_FAIL'

const LOADING = 'downtimeTracker/LOADING'
const LOAD_SUCCESS = 'downtimeTracker/LOAD_SUCCESS';

const initialState = Immutable.fromJS({
    loading: false,
    openIssues: [],
    issuesCount: 0,
    notes: [],
    loadErr: null
})


export default function reducer(state = initialState, action) {
    switch (action.type) {
        case LOADING:
            return state
                .set('loading', true)
        case LOAD_SUCCESS:
            return state
                .set('loading', false)
        case LOAD_OPEN_ISSUES_SUCCESS:
            return state
                .set('openIssues', action.res)
        case LOAD_OPEN_ISSUES_FAIL:
            return state
                .set('openIssues', [])
                .set('loadErr', action.error)
                .set('loading', false)
        case LOAD_NOTES_SUCCESS:
            return state
                .set('notes', action.res)
        case LOAD_NOTES_FAIL:
            return state
                .set('notes', [])
                .set('loadErr', action.error)
                .set('loading', false)
        case SAVE_NOTES_SUCCESS:
            return state
                .set('loading', false)
        case SAVE_NOTES_FAIL:
            return state
                .set('loadErr', action.error)
                .set('loading', false)
        case CHECK_ISSUES_SUCCESS:
            return state
                .set('issuesCount', action.error)
                .set('loading', false)
        case CHECK_ISSUES_FAIL:
            return state
                .set('issuesCount', 0)
                .set('loadErr', action.error)
                .set('loading', false)
        default:
            return state
    }
}

export const getOpenIssues = (app) => async (dispatch, getState, api) => {
    try {
        dispatch({ type: LOADING });
        let res = await api.get(`/downtimeTracker/openIssues?appDown=${app}`);
        dispatch({ type: LOAD_OPEN_ISSUES_SUCCESS, res: res });
        dispatch({ type: LOAD_SUCCESS });
        return res;
    } catch (err) {
        dispatch({ type: LOAD_OPEN_ISSUES_FAIL, error: err.message });
    }
};

export const checkIssues = (app) => async (dispatch, getState, api) => {
    try {
        dispatch({ type: LOADING });
        let res = await api.get(`/downtimeTracker/checkIssues?appDown=${app}`);
        dispatch({ type: CHECK_ISSUES_SUCCESS, res: res });
        dispatch({ type: LOAD_SUCCESS });
        return res;
    } catch (err) {
        dispatch({ type: CHECK_ISSUES_FAIL, error: err.message });
    }
};

export const getNotes = (id) => async (dispatch, getState, api) => {
    try {
        dispatch({ type: LOADING });
        let res = await api.get(`/downtimeTracker/getNotes?id=${id}`);
        dispatch({ type: LOAD_NOTES_SUCCESS, res: res });
        dispatch({ type: LOAD_SUCCESS });
        return res;
    } catch (err) {
        dispatch({ type: LOAD_NOTES_FAIL, error: err.message });
    }
}

export const saveOpenIssueNotes = (payload) => async (dispatch, getState, api) => {
    const user = getState().get('auth').get('user');
    payload.user = user.email
    try {
        let res = await api.post(`/downtimeTracker/saveNotes`, {data: payload});
        dispatch({ type: SAVE_NOTES_SUCCESS, res: res });
    } catch (err) {
        dispatch({ type: SAVE_NOTES_FAIL, error: err.message });
    }
}